import { ProfessionalBackground } from '../types';
import styles from '../form-submissions.module.css';
import { Briefcase, GraduationCap, BookOpen, Layers } from 'lucide-react';

interface ProfessionalCardProps {
  professional: ProfessionalBackground;
}

export function ProfessionalCard({ professional }: ProfessionalCardProps) {
  const getFieldCategoryLabel = (category: string) => {
    switch (category) {
      case 'research':
        return 'Research & Sciences';
      case 'business':
        return 'Business & Commerce';
      case 'arts':
        return 'Arts & Entertainment';
      case 'sports':
        return 'Athletics & Sports';
      default:
        return '—';
    }
  };

  // Calculate experience level
  const years = parseInt(professional.yearsOfExperience) || 0;
  const experienceLevel =
    years >= 15
      ? 'Senior Expert'
      : years >= 10
        ? 'Expert'
        : years >= 5
          ? 'Experienced'
          : 'Early Career';
  const experiencePercentage = Math.min((years / 20) * 100, 100);

  return (
    <div className={styles.sectionCard}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionIcon}>
          <Briefcase size={18} />
        </div>
        <h3 className={styles.sectionTitle}>Professional Background</h3>
      </div>

      <div className={styles.sectionContent}>
        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>
            <Briefcase size={13} />
            Profession
          </span>
          <span className={styles.dataValue}>{professional.profession || '—'}</span>
        </div>

        <div style={{ padding: '8px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span className={styles.dataLabel}>Experience</span>
            <span style={{ fontSize: '13px', color: '#262626' }}>
              {professional.yearsOfExperience} years · {experienceLevel}
            </span>
          </div>
          <div className={styles.progressBar}>
            <div className={styles.progressFill} style={{ width: `${experiencePercentage}%` }} />
          </div>
        </div>

        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>
            <GraduationCap size={13} />
            Education
          </span>
          <span className={styles.dataValue}>{professional.highestEducation || '—'}</span>
        </div>

        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>
            <BookOpen size={13} />
            Field of Study
          </span>
          <span className={styles.dataValue}>{professional.fieldOfStudy || '—'}</span>
        </div>

        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>
            <Layers size={13} />
            Category
          </span>
          <span className={styles.dataValue}>
            {getFieldCategoryLabel(professional.fieldCategory)}
          </span>
        </div>
      </div>
    </div>
  );
}
